import { SalaryModeOptions } from "../constants/employment";

export const getSalaryBasedOnSiteContext = ({
  absoluteSalary,
  siteContext,
  salaryMode,
}: {
  absoluteSalary: number;
  siteContext: string;
  salaryMode: (typeof SalaryModeOptions)[0];
}) => {
  let salary = absoluteSalary;
  if (siteContext === "rexmonster") {
    if (salaryMode && salaryMode.id === SalaryModeOptions[0].uuid) {
      salary = absoluteSalary * 12;
    }
  } else {
    if (salaryMode && salaryMode.id === SalaryModeOptions[1].uuid) {
      salary = Math.floor(absoluteSalary / 12);
    }
  }

  return salary;
};
